export default function ScienceHero() {
  return (
    <section className="pt-32 pb-16 bg-gradient-to-br from-brand-50 via-white to-accent-50">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 text-center">
        <div className="inline-block px-4 py-1.5 bg-brand-50 border border-brand-100 rounded-full mb-5">
          <span className="text-sm font-semibold text-brand-600 tracking-wide font-heading">
            PEER-REVIEWED RESEARCH
          </span>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5 leading-tight font-heading">
          Understanding CSCF Syndrome
        </h1>
        <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed font-body">
          A comprehensive overview of Cardiospondylocarpofacial Syndrome based on published medical
          research. All information is drawn from peer-reviewed journals and case studies.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {['Genetics', 'Symptoms', 'Diagnosis', 'Cardiac', 'Skeletal', 'Case Studies', 'Research'].map(
            (tag) => (
              <span
                key={tag}
                className="px-3 py-1 bg-white border border-gray-200 rounded-full text-xs font-medium text-gray-600 font-body shadow-sm"
              >
                {tag}
              </span>
            )
          )}
        </div>
      </div>
    </section>
  );
}
